// extracted by mini-css-extract-plugin
module.exports = {"container":"History_container__1ZxT8","error":"History_error__wXz8c","infinityScroll":"History_infinityScroll__yqGsw","title":"History_title__q0tFO"};